/// <reference path="../typings.d.ts" />
import { OnInit, Component } from '@angular/core';
import { FormControl, AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { IdentityUser } from './models/identity_user';
import { Alert } from './shared/alert';
import { InviteUser } from './models/invite_user';
import { User } from './models/user';
import { IdentityService } from './services/identity.service';
import { AppTitle } from './shared/title';
import { AppValidators, controlErrors } from './shared/app.validators';
import { Account, validateToken } from './services/account.service';

@Component({
	selector: 'user-management',
	styles: [`
        .tag {
            margin-right:2px;
            background-color:#e0e0e0;
            border-radius:4px;
            padding:5px;
        }
		.tag-close {
			margin-left:5px;
	  	    cursor: pointer;
	    }
    `],
	template: `
	<div class="row" [hidden]="msgHead.msg == ''">
		<div class="col-lg-8 col-md-6 col-xs-12">
			<alert [alert]="msgHead"></alert>
		</div>
	</div>
	<div *ngIf="hasAccess" class="row">
		<div class="col-lg-12 col-md-12 col-xs-12" style="padding:0px; margin-bottom:0px;">
			<form [formGroup]="form" novalid>
				<div class="row">
					<div class="col-lg-3 col-md-6 col-xs-12" style="margin-bottom: 0px;">
						<div class="form-group">
                            <p class="custom-label">Email Address</p>
							<input type="text" [(ngModel)]="fobj.email" formControlName="email" class="form-control" placeholder="Email" title="Email Address">
						</div>
					</div>
				</div>
			</form>
		</div>
		<div class="col-lg-12 col-md-12 col-xs-12" style="margin-top:0px;">
			<button type="button" class="btn btn-large btn-primary" (click)="invite()">Invite</button>
		</div>
	</div>
	  <div *ngIf="hasAccess" class="row">
		<div class="col-lg-6 col-md-6 col-xs-12">
			<alert [alert]="msg" style="display:block;"></alert>
		</div>
	  </div>
	<div *ngIf="hasAccess" class="row">
		<div class="col-lg-8 col-md-12 col-xs-12">
			<div class="card">
				<table class="table">
					<thead>
						<tr>
							<th>Name</th>
							<th>Email</th>
							<th>Status</th>
							<th>Roles</th>
							<th>Owner</th>
							<th>Actions</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let row of data; let i = index">
							<td style="width:25%;">{{user.userId != row.userId ? row.firstName + ' ' +row.lastName : 'You'}}</td>
							<td style="width:25%;">{{row.email}}</td>
							<td style="width:10%;">{{row.status}}</td>
							<td>
								<span class="tag" *ngFor="let role of row.roles; let j = index" style="padding: 2px 4px; display: inline-block; margin-bottom: 3px; margin-right: 3px;">{{role}} <span (click)="removeRole(row,j)" class="tag-close">x</span></span>
								<span title="Add Role" class="dropdown" [class.open]="row.openAddRole" [offClick]="clickedOutside">
						  <span style="font-size:10px;" class="glyphicon glyphicon-plus" style="cursor:pointer;" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" (click)="openAddRole(row)" >
						  </span>
								<ul class="dropdown-menu">
									<li *ngFor="let r of roles"><a (click)="addRole(row,r)">{{r}}</a></li>
								</ul>
								</span>
							</td>
							<td style="width:10%;">{{row.owner}}</td>
							<td style="width:5%;">
								<span title="Remove User" class="glyphicon glyphicon-trash" style="cursor:pointer;" aria-hidden="true" (click)="removeUser(row)"></span>
								<span *ngIf="row.status=='invite'" title="Re-invite User" class="glyphicon glyphicon-envelope" style="margin-left:5px;" aria-hidden="true" (click)="reInvite(row)"></span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
   `
})

export class UserManagementComponent implements OnInit {
	data: IdentityUser[];
	cardRows: number[]; //cards rows
	msg: Alert;
	msgHead: Alert;
	acctNumber: string;
	form: FormGroup;
	fobj: InviteUser;
	roles: string[];
	hasAccess: boolean;
	maxPageSize: number;
	currentRow: IdentityUser;
	user: User;
	constructor(private account: Account, private router: Router, private isvc: IdentityService, fb: FormBuilder, private title: AppTitle, private activatedRoute: ActivatedRoute) {
		this.hasAccess = true;
		this.msg = new Alert();
		this.msgHead = new Alert();
		title.setTitles({
			title: 'User Management',
			dashboard: 'User Management'
		});
		this.title.setBreadcrumbs([
			{ title: 'User Management', link: `` }
		]);
		this.form = fb.group({
			email: ['', Validators.compose([Validators.required, AppValidators.email])],
		});
		this.fobj = new InviteUser()
		this.maxPageSize = 20;
		this.data = [];
		this.roles = ['admin']
		this.currentRow = new IdentityUser();
		this.clickedOutside = this.clickedOutside.bind(this);
	}

	ngOnInit() {
		this.acctNumber = this.activatedRoute.snapshot.params['acctNumber'];
		if (this.acctNumber != null) {
			this.isvc.validateAcctNumber(this.acctNumber)
				.subscribe(res => {
					if (!res) {
						this.msgHead.error("You don't have access to this district number " + this.acctNumber);
						this.hasAccess = false;
					}
				}, err => {
					console.log(err);
					let e = this.isvc.getUserErrorDefault(err);
					this.msgHead.error(e);
					this.hasAccess = false;
				});
		}
		this.loadData();
		this.user = this.account.getUser();
	}

	view() {
		if (!validateToken()) {
			this.router.navigate(['/login']);
			return
		}
		if (!this.form.valid) {
			this.displayErrors(this.form);
			return;
		}
		this.loadData();
	}

	loadData() {
		this.isvc.usersApi(this.acctNumber).subscribe((urs: IdentityUser[]) => {
			this.data = urs;
			this.msg.close();
		}, err => {
			console.log(err);
			if (this.isvc.isErrNotFound(err)) {
				this.msg.warning(this.isvc.getUserError(err));
			} else {
				if (this.isvc.isErrUnauthorized(err)) {
					this.hasAccess = false;
					this.msgHead.error(this.isvc.getUserErrorDefault(err));
				} else {
					this.msg.error(this.isvc.getUserErrorDefault(err));
				}
			}
		});
	}

	displayErrors(f: FormGroup) {
		var message = '';
		controlErrors(f, (c: any, err: any) => {
			message += err + '<br>';
		});
		this.msg.errorHtml(message);
	}

	removeRole(row: IdentityUser, idx: number) {
		this.msgHead.close();
		this.msg.close();
		if (this.user.userId == row.userId && row.roles[idx] == 'admin') {
			this.msgHead.error('You can not remove yourself from admin role, please use another account to remove this role.');
			return;
		}
		row.roles.splice(idx, 1);
		this.isvc.updateUserApi(this.acctNumber, row)
			.subscribe(res => {
			}, err => {
				console.log(err);
				let e = this.isvc.getUserErrorDefault(err);
				this.msgHead.error(e);
			});
	}

	addRole(row: IdentityUser, role) {
		this.msgHead.close();
		this.msg.close();
		if (row.roles.indexOf(role) == -1) {
			row.roles.push(role);
			this.isvc.updateUserApi(this.acctNumber, row)
				.subscribe(res => {
				}, err => {
					console.log(err);
					let e = this.isvc.getUserErrorDefault(err);
					this.msgHead.error(e);
				});
		}
		this.clickedOutside();
	}

	openAddRole(row: IdentityUser) {
		row.openAddRole = !row.openAddRole;
		this.currentRow = row;
	}

	clickedOutside() {
		if (this.currentRow != null) {
			this.currentRow.openAddRole = false;
		}
	}

	invite() {
		if (!validateToken()) {
			this.router.navigate(['/login']);
			return;
		}
		if (!this.form.valid) {
			this.displayErrors(this.form);
			return;
		}
		this.msgHead.close();
		this.msg.close();
		this.isvc.inviteUserApi(this.acctNumber, this.fobj)
			.subscribe(res => {
				for (var v in this.data) {
					if (this.data[v].email == res.email) {
						this.msg.success(`We have sent re-invite email to ${res.email}.`);
						return;
					}
				}
				this.data.push(res);
				this.msg.success(`We have sent invite email to ${res.email}.`);
			}, err => {
				console.log(err);
				let e = this.isvc.getUserErrorDefault(err);
				this.msgHead.error(e);
			});
	}

	removeUser(row: IdentityUser) {
		if (!validateToken()) {
			this.router.navigate(['/login']);
			return;
		}
		if (this.user.userId == row.userId) {
			this.msgHead.error('You can not remove yourself, please use another account to remove this user.');
			return;
		}
		this.msgHead.close();
		this.msg.close();
		if (row.owner == 'user') {
			this.isvc.removeUserApi(this.acctNumber, row)
				.subscribe(res => {
					this.data.splice(this.data.indexOf(row), 1);
				}, err => {
					console.log(err);
					let e = this.isvc.getUserErrorDefault(err);
					this.msgHead.error(e);
				});
		}
		this.clickedOutside();
	}

	reInvite(row: IdentityUser) {
		let req = new InviteUser();
		req.email = row.email;
		this.isvc.inviteUserApi(this.acctNumber, req)
			.subscribe(res => {
				for (var v in this.data) {
					if (this.data[v].email == res.email) {
						this.msg.success(`We have sent re-invite email to ${res.email}.`);
						return;
					}
				}
				this.data.push(res);
			}, err => {
				console.log(err);
				let e = this.isvc.getUserErrorDefault(err);
				this.msgHead.error(e);
			});
	}
}
